import { addSingleCube } from './singleAdd';
import { addGoodsGroup } from './groupAdd';

function init(): void {
    // 单个组件新增
    addSingleCube();

    // 商品批量上图
    addGoodsGroup();
}

export default {
    init
};
